<template>
  <EditFines v-show="fines" :accident="fines" />
</template>
<script>
import EditFines from './add'
import { getAFine } from '@/api/fines'
import { gregorianToJalali } from '@/mixins/gregorianToJalali'
import { currency } from '@/mixins/currency'

export default {
  mixins: [gregorianToJalali, currency],
  data() {
    return {
      fines: null,
      loading: true,
    }
  },
  components: {
    EditFines,
  },
  created() {
    getAFine.api(this.$route.params.id).then((res) => {
      this.fines = {
        ...res,
        id: this.$route.params.id,
        date: this.gregorianToJalali(res.date),
        disabled: this.$route.name.includes('VIEW') ? true : false,
        company_vehicle: res.company_vehicle.id,
        driver: res.driver.id,
        type: res.type.id,
        cost: this.currency(res.cost),
        // type: res.type.map((i) => i.id),
      }
      this.loading = false
    })
  },
}
</script>
